import {useDense} from "./useDense";

/**
 * Resolves size ("small" | "medium") from useDense
 */
export const useComponentSizeFromDense = () : "small" | "medium" => {
  const dense = useDense();
  return dense ? "small" : "medium";
}
